export enum SharesproApiErrorCode {
  ReportNotReady = 'REPORT_NOT_READY',
  SubscriptionRequired = 'SUBSCRIPTION_REQUIRED',
  NotFound = 'NOT_FOUND',
  AccessDenied = 'ACCESS_DENIED',
  ServerError = 'INTERNAL_ERROR',
  CaptchaRequired = 'CAPTCHA_REQUIRED',
  SessionNotFound = 'SESSION_UUID_NOT_FOUND',
  InvalidRequest = 'INVALID_REQUEST',
  Unknown = 'UNKNOWN',
}
